import maturityModel from "@/assets/images/banners/maturity-model.png";

export const maturityModelSectionData = {
  heading: "Empowering optimal cybersecurity maturity models",
  imageUrl: maturityModel.src,
};
